<template>
  <div class="complaint_modal modal" v-if="$store.state.main.complaint_modal">
    <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
    <div
      class="complaint_modal__inner bg-white"
      :class="{ mob_100: windowWidth <= 767 }"
    >
      <div class="complaint_modal__ttl_wrapper flex j_sb a_center">
        <span class="f-24 bold uppercase" v-if="!success_sent">{{
          $fn.tr("პრეტენზიის დაფიქსირება")
        }}</span>
        <span class="f-24 bold uppercase f-light-purple" v-else>{{
          $fn.tr("აპლიკაცია წარმატებით გაიგზავნა")
        }}</span>
        <div class="complaint_modal__x_btn pointer" @click="close_modal()">
          <svg
            id="Group_4238"
            data-name="Group 4238"
            xmlns="http://www.w3.org/2000/svg"
            width="16.971"
            height="16.971"
            viewBox="0 0 16.971 16.971"
          >
            <rect
              id="Rectangle_543"
              data-name="Rectangle 543"
              width="20"
              height="4"
              rx="2"
              transform="translate(2.828 0) rotate(45)"
            />
            <rect
              id="Rectangle_1219"
              data-name="Rectangle 1219"
              width="20"
              height="4"
              rx="2"
              transform="translate(16.971 2.829) rotate(135)"
            />
          </svg>
        </div>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="complaint_modal__form"
        v-show="!success_sent"
      >
        <el-form-item prop="name">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--name"
            :class="{ selected: ruleForm.name.length !== 0 }"
            >{{ $fn.tr("შეტყობინების ავტორი") }}</span
          >
          <el-input
            v-model="ruleForm.name"
            @focus="add_focus('name')"
            @blur="remove_focus('name', ruleForm.name)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="email">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--email"
            :class="{ selected: ruleForm.email.length !== 0 }"
            >{{ $fn.tr("ელ-ფოსტა") }}</span
          >
          <el-input
            v-model="ruleForm.email"
            type="email"
            @focus="add_focus('email')"
            @blur="remove_focus('email', ruleForm.email)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--phone"
            :class="{ selected: ruleForm.phone.length !== 0 }"
            >{{ $fn.tr("ნომერი") }}</span
          >

          <el-input
            v-model.number="ruleForm.phone"
            @focus="add_focus('phone')"
            @blur="remove_focus('phone', ruleForm.phone)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="policy_number">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--policy_number"
            :class="{ selected: ruleForm.policy_number.length !== 0 }"
            >{{ $fn.tr("პოლისის ნომერი") }}</span
          >

          <el-input
            v-model.number="ruleForm.policy_number"
            @focus="add_focus('policy_number')"
            @blur="remove_focus('policy_number', ruleForm.policy_number)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="address">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--address"
            :class="{ selected: ruleForm.address.length !== 0 }"
            >{{ $fn.tr("ფაქტობრივი მისამართი") }}</span
          >

          <el-input
            v-model="ruleForm.address"
            @focus="add_focus('address')"
            @blur="remove_focus('address', ruleForm.address)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="subject">
          <el-select
            v-model="ruleForm.subject"
            :placeholder="$fn.tr('რას ეხება თქვენი უკმაყოფილება?')"
          >
            <el-option
              v-for="item in _.get(
                $store.state.main.indx.terms,
                'complaint_topics'
              )"
              :key="item.id"
              :label="item.title"
              :value="item.title"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <span class="medium f-16 complaint_modal__radio_label">{{
          $fn.tr(
            "გთხოვთ, მონიშნოთ, თუ გსურთ თქვენს შეტყობინებაზე პასუხის მიღება?"
          )
        }}</span>

        <el-form-item prop="resource">
          <el-radio-group v-model="ruleForm.need_response">
            <el-radio :label="$fn.tr('კი')"></el-radio>
            <el-radio :label="$fn.tr('არა')"></el-radio>
          </el-radio-group>
          <p class="f-14 regular">
            {{
              _.get(
                $store.state.main.indx.widgets.complaint_management,
                "content.teaser"
              )
            }}&nbsp;
            <a
              class="f-14 regular f-light-purple underline"
              :href="
                _.get(
                  $store.state.main.indx.widgets.complaint_management,
                  'content.url'
                )
              "
              >{{
                _.get(
                  $store.state.main.indx.widgets.complaint_management,
                  "content.title"
                )
              }}</a
            >
          </p>
        </el-form-item>

        <el-form-item prop="desc">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--textarea"
            :class="{ selected: ruleForm.desc.length !== 0 }"
            >{{ $fn.tr("გთხოვთ, დეტალურად გაგვაცნოთ ვითარება") }}</span
          >

          <el-input
            type="textarea"
            v-model="ruleForm.desc"
            @focus="add_focus('textarea')"
            @blur="remove_focus('textarea', ruleForm.desc)"
          ></el-input>
        </el-form-item>

        <div class="complaint_modal__terms flex">
          <span class="f-16 regular"
            >{{
              _.get(
                this.$store.state.main.current_content,
                "primary.conf.header.teaser"
              )
            }}
            <a
              :href="
                _.get(
                  this.$store.state.main.current_content,
                  'primary.conf.header.full_list_url'
                )
              "
              class="f-16 regular"
            >
              {{
                _.get(
                  this.$store.state.main.current_content,
                  "primary.conf.header.full_list_title"
                )
              }}
            </a>
          </span>
        </div>

        <span class="f-16 medium" :style="{display: 'block', marginBottom: '32px'}">
          გაცნობებთ, რომ თქვენ მიერ დაფიქსირებულ ინფორმაციას განიხილავს თიბისი
          დაზღვევის ხარისხის მართვის განყოფილება, 10 სამუშაო დღის ვადაში.
        </span>
        <el-form-item>
          <el-button
            class="button complaint_modal_validate_button"
            @click="submitForm('ruleForm')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("გაგზავნა")
            }}</span>
          </el-button>
        </el-form-item>
      </el-form>

      <div
        class="complaint_modal__success flex column a_center"
        v-show="success_sent"
      >
        <img :src="_.get($store.state.main.selected_menu.media.cover, 'url')" />
        <span class="f-16 medium">{{
          $fn.tr("პრეტენზია წარმატებით დაფიქსირდა")
        }}</span>
        <div
          class="complaint_modal__success--button button flex a_center j_center f-white bold uppercase pointer"
          @click="back_to_complaint()"
        >
          <svg
            id="Group_5_Copy_3"
            data-name="Group 5 Copy 3"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
              fill="#fff"
            />
          </svg>
          {{ $fn.tr("კონტაქტის გვერდზე დაბრუნება") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
import fn from "@/helpers/func";
export default {
  props: ["complaint_data"],
  mixins: [resize_handler, fix_100_vh_android],

  data() {
    let validate_phone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
        } else {
          callback();
        }
      }, 1000);
    };
    let validate_name = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };
    let validate_policy_number = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };

    let validate_subject = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };

    let validate_need_response = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("მონიშვნა სავალდებულოა")));
      } else {
        callback();
      }
    };

    let validate_email = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!value.includes("@")) {
          callback(new Error(this.$fn.tr("გთხოვთ სწორად შეიყვანოთ იმეილი")));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      success_sent: false,
      file_list: [],
      file_obj: "",
      focuses: [],
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        policy_number: "",
        address: "",
        desc: "",
        subject: "",
        need_response: ""
      },
      rules: {
        name: [{ validator: validate_name, trigger: "blur" }],
        //   policy_number: [
        //   { validator: validate_policy_number, trigger: 'blur' }
        // ],

        // subject: [
        //   { validator: validate_subject, trigger: 'blur' }
        // ],

        need_response: [{ validator: validate_need_response, trigger: "blur" }],

        email: [{ validator: validate_email, trigger: "blur" }],
        phone: [{ validator: validate_phone, trigger: "blur" }]
      }
    };
  },
  mounted() {
    // console.log(this.complaint_data);
    this.success_sent = false;
  },
  methods: {
    add_focus(name) {
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _address = document.querySelector(".el-input__placeholder--address");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      let _policy_number = document.querySelector(
        ".el-input__placeholder--policy_number"
      );
      if (!this.focuses.includes(name)) this.focuses.push(name);
      if (name == "name") {
        _name.classList.add("selected");
      } else if (name == "email") {
        _email.classList.add("selected");
      } else if (name == "phone") {
        _phone.classList.add("selected");
      } else if (name == "address") {
        _address.classList.add("selected");
      } else if (name == "textarea") {
        _textarea.classList.add("selected");
      } else if (name == "policy_number") {
        _policy_number.classList.add("selected");
      }
    },
    remove_focus(name, field) {
      this.focuses = this.focuses.filter(foc => foc !== name);
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _address = document.querySelector(".el-input__placeholder--address");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      let _policy_number = document.querySelector(
        ".el-input__placeholder--policy_number"
      );
      if (field.length == 0) {
        if (name == "name") {
          _name.classList.remove("selected");
        } else if (name == "email") {
          _email.classList.remove("selected");
        } else if (name == "phone") {
          _phone.classList.remove("selected");
        } else if (name == "address") {
          _address.classList.remove("selected");
        } else if (name == "textarea") {
          _textarea.classList.remove("selected");
        } else if (name == "policy_number") {
          _policy_number.classList.remove("selected");
        }
      }
    },

    back_to_complaint() {
      this.success_sent = false;

      this.$refs["ruleForm"].resetFields();

      this.close_modal();
    },

    close_modal() {
      document.querySelector(".modal").classList.remove("modal_active");
      setTimeout(() => {
        this.$store.state.main.complaint_modal = !this.$store.state.main
          .complaint_modal;
      }, 701);
    },

    async submit_form() {
      let params = {
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        email: this.ruleForm.email,
        text: this.ruleForm.desc,
        address: this.ruleForm.address,
        subject: this.ruleForm.subject,
        policy_number: this.ruleForm.policy_number,
        need_response: this.ruleForm.need_response,
        formType: "complaint_form"
      };

      let res = await fn.postData("main/saveSubmitedForm", params);
      this.success_sent = true;
      console.log(res);
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit_form();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    complaint_modal() {
      return this.$store.state.main.complaint_modal;
    }
  },
  watch: {
    complaint_modal(ns, os) {
      if (ns == true) {
        setTimeout(() => {
          document
            .querySelector(".complaint_modal")
            .classList.add("modal_active");
        }, 10);
      }
      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    },

    focuses(ns, os) {
      console.log(ns);
    },
    $route(to, from) {
      if (this.$store.state.main.complaint_modal) {
        this.$store.state.main.complaint_modal = !this.$store.state.main
          .complaint_modal;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
